import React from 'react';

interface Tab {
  id: string;
  label: string;
}

interface AdminTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

/**
 * AdminTabs - Tab navigation component for admin pages
 * Uses Tailwind CSS for styling
 */
export const AdminTabs: React.FC<AdminTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = '',
}) => {
  return (
    <div
      className={`
        flex
        border-b border-[#333333]
        mb-5
        mt-[13px]
        overflow-x-auto
        ${className}
      `}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`
            px-4 py-3
            text-base font-medium
            cursor-pointer
            border-b-[3px]
            mr-3
            transition-colors duration-200
            whitespace-nowrap
            ${
              activeTab === tab.id
                ? 'text-[#F4CC04] border-[#F4CC04]'
                : 'text-white border-transparent hover:text-[#F4CC04]'
            }
          `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default AdminTabs;
